enum CustomEvent {
  INSTALL_CLICK = 'install_button_click',
}

interface CustomEventsParamsMap {
  [CustomEvent.INSTALL_CLICK]: InstallClickParams;
}

export interface PageViewParams {
  wix_referring_page: string | undefined;
  wix_referring_page_details: string | undefined;
  app_position_in_source: string | undefined;
}

export interface DefaultParams {
  send_to: string;
  deviceType: 'desktop' | 'mobile';
  app_market_platform: string;
  user_id: string | undefined;
  user_site_id: string | undefined;
  site_premium_subscription_status: string;
}

interface InstallClickParams {}

export { CustomEvent, CustomEventsParamsMap };
